// Nigerian states with major cities
export const NIGERIA_STATES_CITIES = {
  "LA": { name: "Lagos", cities: ["Lagos Island", "Ikeja", "Victoria Island", "Lekki", "Surulere", "Yaba", "Ikoyi", "Ajah", "Oshodi", "Mushin", "Agege", "Alimosho", "Badagry", "Epe", "Ikorodu"] },
  "AB": { name: "Abia", cities: ["Umuahia", "Aba", "Ohafia", "Arochukwu"] },
  "FC": { name: "FCT Abuja", cities: ["Abuja", "Gwagwalada", "Kuje", "Bwari", "Kubwa", "Nyanya", "Maitama", "Garki", "Wuse"] },
  "KN": { name: "Kano", cities: ["Kano", "Wudil", "Gwarzo", "Rano", "Bichi"] },
  "OG": { name: "Ogun", cities: ["Abeokuta", "Sagamu", "Ijebu-Ode", "Ota", "Ilaro"] },
  "OY": { name: "Oyo", cities: ["Ibadan", "Ogbomoso", "Oyo", "Iseyin", "Saki"] },
  "RV": { name: "Rivers", cities: ["Port Harcourt", "Obio-Akpor", "Bonny", "Degema", "Ahoada"] },
  "AN": { name: "Anambra", cities: ["Awka", "Onitsha", "Nnewi", "Ekwulobia", "Aguata"] },
  "EN": { name: "Enugu", cities: ["Enugu", "Nsukka", "Agbani", "Udi", "Oji River"] },
  "IM": { name: "Imo", cities: ["Owerri", "Orlu", "Okigwe", "Oguta", "Mbaise"] },
  "DL": { name: "Delta", cities: ["Asaba", "Warri", "Sapele", "Ughelli", "Agbor", "Ozoro"] },
  "ED": { name: "Edo", cities: ["Benin City", "Auchi", "Ekpoma", "Uromi", "Irrua"] },
  "KD": { name: "Kaduna", cities: ["Kaduna", "Zaria", "Kafanchan", "Kagoro"] },
  "KW": { name: "Kwara", cities: ["Ilorin", "Offa", "Jebba", "Lafiagi"] },
  "OS": { name: "Osun", cities: ["Osogbo", "Ile-Ife", "Ilesa", "Ede", "Iwo"] },
  "EK": { name: "Ekiti", cities: ["Ado-Ekiti", "Ikere-Ekiti", "Iyin-Ekiti", "Ijero-Ekiti"] },
  "ON": { name: "Ondo", cities: ["Akure", "Ondo", "Owo", "Ikare", "Ore"] },
  "BO": { name: "Borno", cities: ["Maiduguri", "Biu", "Bama", "Dikwa"] },
  "CR": { name: "Cross River", cities: ["Calabar", "Ogoja", "Ikom", "Obudu"] },
  "AK": { name: "Akwa Ibom", cities: ["Uyo", "Eket", "Ikot Ekpene", "Oron"] },
  "PL": { name: "Plateau", cities: ["Jos", "Bukuru", "Pankshin", "Shendam"] },
  "NI": { name: "Niger", cities: ["Minna", "Bida", "Suleja", "Kontagora"] },
  "SO": { name: "Sokoto", cities: ["Sokoto", "Tambuwal", "Wurno", "Bodinga"] },
  "BA": { name: "Bauchi", cities: ["Bauchi", "Azare", "Misau", "Jama'are"] },
  "AD": { name: "Adamawa", cities: ["Yola", "Jimeta", "Mubi", "Numan"] },
  "BE": { name: "Benue", cities: ["Makurdi", "Gboko", "Otukpo", "Katsina-Ala"] },
  "KO": { name: "Kogi", cities: ["Lokoja", "Okene", "Idah", "Kabba"] },
  "NA": { name: "Nasarawa", cities: ["Lafia", "Keffi", "Akwanga", "Nasarawa"] },
  "TA": { name: "Taraba", cities: ["Jalingo", "Wukari", "Bali", "Takum"] },
  "ZA": { name: "Zamfara", cities: ["Gusau", "Kaura Namoda", "Talata Mafara"] },
  "KT": { name: "Katsina", cities: ["Katsina", "Daura", "Funtua", "Malumfashi"] },
  "JI": { name: "Jigawa", cities: ["Dutse", "Hadejia", "Gumel", "Kazaure"] },
  "KE": { name: "Kebbi", cities: ["Birnin Kebbi", "Argungu", "Yauri", "Zuru"] },
  "GO": { name: "Gombe", cities: ["Gombe", "Kumo", "Billiri", "Kaltungo"] },
  "YO": { name: "Yobe", cities: ["Damaturu", "Potiskum", "Gashua", "Nguru"] },
  "BY": { name: "Bayelsa", cities: ["Yenagoa", "Brass", "Ogbia", "Sagbama"] },
  "EB": { name: "Ebonyi", cities: ["Abakaliki", "Afikpo", "Onueke", "Ishielu"] }
};
